import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { TableColumnDef } from "../../components/DataTable";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

type ColumnActions = {
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  lang: ContentLanguage;
};

export const buildServiceItemsColumns = ({
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  lang,
}: ColumnActions): TableColumnDef[] => [
  {
    header: "Name",
    render: (row: any) => (lang === "de" ? row?.itemsName_ger : row?.itemsName) || "-",
    getValue: (row: any) => lang === "de" ? row?.itemsName_ger : row?.itemsName,
  },
  {
    header: "Artikel Preis",
    render: (row: any) => row?.itemsPrice,
    getValue: (row: any) => row?.itemsPrice,
  },
  {
    header: "Kategorie",
    render: (row: any) => row?.categoryId?.categoryName,
    getValue: (row: any) => row?.categoryId?.categoryName,
  },
  {
    header: "Einstellungen",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {canEdit && (
          <Tooltip title="Bearbeiten" arrow>
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <CreateIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="L&ouml;schen" arrow>
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
